export default __webpack_public_path__ + "static/media/THSarabun BoldItalic.88898ec1.ttf";